export default __webpack_public_path__ + "static/media/BB_37.0b61938c.png";